import React from 'react';
import styles from './CurrencyChangeWarningOverlay.module.scss';
import { useCurrencyContext } from 'app/contexts/Currency/CurrencyContext';
import { Currency } from 'shared/components/CurrencySelect/types';
import { ExternalLinks } from 'shared/enums/external-links.enum';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';

interface CurrencyChangeWarningOverlayProps {
  adminChangedCurrencySymbol: string | null;
  selectedCurrency: Currency | null;
  onDismiss: () => void;
}

export const CurrencyChangeWarningOverlay: React.FC<CurrencyChangeWarningOverlayProps> = ({
  adminChangedCurrencySymbol,
  selectedCurrency,
  onDismiss,
}: CurrencyChangeWarningOverlayProps): React.ReactNode => {
  const currencyContext = useCurrencyContext();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.noticeText}>
          <span className={styles.noticeTitle}>Notice:</span>
          <span className={styles.noticeBody}>
            Your account’s processing currency has been updated to {currencyContext.isProcessingCurrencyChangedByAdmin} by
            the Admin. The change will appear in the platform once your session is refreshed.
          </span>
          <div>
            <a href={ExternalLinks.CurrenciesDocumentation} target="_blank" className={styles.navigateText}>
              Learn more
            </a>
          </div>
        </div>
        <div className={styles.warningIconContainer}>
          <div className={styles.warningIcon}>
            <div className={styles.warningIconText}>{adminChangedCurrencySymbol}</div>
          </div>
          <GenerateIcon iconName={ICONS.right.name} className={styles.rightIcon} />
          <div className={styles.warningIcon}>
            <div className={styles.warningIconText}>{selectedCurrency?.symbolNative}</div>
          </div>
        </div>
      </div>
      <GenerateIcon
        className={styles.closeButton}
        iconName={ICONS.xMark.name}
        onClick={() => onDismiss()}
      ></GenerateIcon>
    </div>
  );
};
